import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeConverter',
  standalone: true,
})
export class TimeConverterPipe implements PipeTransform {
  transform(value: string): string {
    const timePart = value.split('T')[1];
    const hourMinutePart = timePart ? timePart.split(':') : [];
    return hourMinutePart.length > 1 ? `${hourMinutePart[0]}:${hourMinutePart[1]}` : '';
  }
}

